var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var PencilUnderlineIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 44,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M32.67 0C33.253 0 33.803 0.227617 34.21 0.628655L34.221 0.639494L42.416 8.71447C43.263 9.5599 43.263 10.9148 42.416 11.7494L15.774 38.0011C15.499 38.2613 15.158 38.4564 14.784 38.5539L3.68499 41.4045C2.93699 41.5996 2.14499 41.3937 1.59499 40.8518C1.05599 40.3098 0.83599 39.5294 1.03399 38.7924L3.92699 27.8559C4.01499 27.4874 4.21299 27.1514 4.48799 26.8804L31.13 0.628655C31.537 0.227617 32.087 0 32.67 0ZM32.67 5.17015L7.98599 29.5035L6.17099 36.3428L13.112 34.5544L37.796 10.2211L32.67 5.17015ZM0 47.8323C0 46.64 0.99 45.6645 2.2 45.6645H41.8C43.01 45.6645 44 46.64 44 47.8323C44 49.0246 43.01 50.0001 41.8 50.0001H2.2C0.99 50.0001 0 49.0246 0 47.8323Z",
    fill: "black"
  }));
};
export var PencilUnderlineIconGlyph = function (props) {
  return React.createElement(PencilUnderlineIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};